(function() {
    'use strict';

    angular.module('order', [
            'ui.router',

            'order.constants',
            'order.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'orderPermissionsConst', 'invoicePermissionsConst', 'optimaPermissionsConst', 'paymentImportPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, orderPermissionsConst, invoicePermissionsConst, optimaPermissionsConst, paymentImportPermissionsConst) {
        $stateProvider
            .state('layout.order', {
                abstract: true,
                url: '/order',
                data: {
                    title: 'Zamówienia',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.order.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/order/views/order-list/order-list.html',
                        controller: 'OrderListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: orderPermissionsConst.view
                }
            })
            .state('layout.order.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/order/views/order-create/order-create.html',
                        controller: 'OrderCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: orderPermissionsConst.view
                }
            })
            .state('layout.order.send', {
                url: '/send',
                views: {
                    'main@layout': {
                        templateUrl: 'app/order/views/order-send-check/order-send-check.html',
                        controller: 'OrderSendCheckController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Wysyłanie zamówienia',
                    modelPermission: orderPermissionsConst.send
                }
            })
            .state('layout.order.sendUps', {
                url: '/send/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/order/views/order-send-ups/order-send-ups.html',
                        controller: 'OrderSendUpsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Pakowanie zamówienia',
                    modelPermission: orderPermissionsConst.send
                }
            })
            .state('layout.order.details', {
                url: '/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/order/views/order-details/order-details.html',
                        controller: 'OrderDetailsController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: orderPermissionsConst.view
                }
            });

        $stateProvider
            .state('layout.invoice', {
                abstract: true,
                url: '/invoices',
                data: {
                    title: 'Faktury',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.invoice.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/order/views/invoice-list/invoice-list.html',
                        controller: 'InvoiceListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: invoicePermissionsConst.view
                }
            })
            .state('layout.invoice.legacy_list', {
                url: '/legacy_list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/order/views/invoice-legacy-list/invoice-legacy-list.html',
                        controller: 'InvoiceLegacyListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: invoicePermissionsConst.view
                }
            });

        $stateProvider
            .state('layout.operation', {
                abstract: true,
                url: '/operation',
                data: {
                    title: 'Optima - eksport wpłat',
                    permission: userPermissionsConst.user
                },
                views: {
                    'main@layout': {
                        templateUrl: 'app/order/views/operation-layout/operation-layout.html',
                        controller: 'OperationLayoutController',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('layout.operation.dotpay', {
                url: '/dotpay',
                views: {
                    'operations@layout.operation': {
                        templateUrl: 'app/order/views/operation-dotpay/operation-dotpay.html',
                        controller: 'OperationDotpayController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: optimaPermissionsConst.view
                }
            })
            .state('layout.operation.pko', {
                url: '/pko',
                views: {
                    'operations@layout.operation': {
                        templateUrl: 'app/order/views/operation-pko/operation-pko.html',
                        controller: 'OperationPkoController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: optimaPermissionsConst.view
                }
            });

        $stateProvider
            .state('layout.payment', {
                abstract: true,
                url: '/payment',
                data: {
                    title: 'Import wpłat',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.payment.import', {
                url: '/import',
                views: {
                    'main@layout': {
                        templateUrl: 'app/order/views/payment_import/payment_import.html',
                        controller: 'PaymentImportController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: paymentImportPermissionsConst.view
                }
            });
    }
})();
